export default {
  name: "McTable",
  props: {
    data: {
      type: Array,
      required: true
    },
    /**
     * 表格列配置数组。
     * @type {Array<{label: string, prop: string, label_desc?: string, width?: string}>}
     *
     * @property {string} label        - 列标题显示文本
     * @property {string} prop         - 对应 data 行数据的字段 key，也用作具名插槽名称
     * @property {string} [label_desc] - 列标题的次要说明（显示在标题后，带 secondary-text 样式）
     * @property {string} [width]      - 列宽度 CSS 值，如 "200px"、"30%"；不传则 flex: 1 均分剩余空间
     *
     * @example
     * // 基本用法
     * columns: [
     *   { label: '名称', prop: 'name', width: '200px' },
     *   { label: '描述', prop: 'desc', label_desc: '(副标题)' },
     *   { label: '操作', prop: 'actions' },
     * ]
     */
    columns: {
      type: Array,
      required: true
    },
    noHeader: {
      default: false
    }
  },
  methods: {
    computedWidth({
      width
    }) {
      return {
        flex: width ? `0 0 ${width}` : 1
      };
    }
  }
};